import { TextField, useFormField } from '@calendly/form'

import { normalizeUrl } from 'services/url'

export const UrlField = (props) => {
  const [{ value }, _meta, { setValue }] = useFormField(props)

  return (
    <TextField
      placeholder="https://www.example.com"
      onBlur={() => {
        if (value) setValue(normalizeUrl(value))
      }}
      {...props}
    />
  )
}
